import React from 'react';
import { Monitor, Mail, FileText, Target, TrendingUp, Settings, BarChart, CheckCircle2, Home, Users, Star, Moon, HelpCircle, Smartphone, Layers } from 'lucide-react';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Breadcrumbs } from '../components/ui/Breadcrumbs';
import { Input } from '../components/ui/Input';
import { useToast } from '../components/ui/Toast';
import { Badge } from '../components/ui/Badge';
interface AdvertisingPageProps {
  onNavigate: (page: string) => void;
}
export function AdvertisingPage({
  onNavigate
}: AdvertisingPageProps) {
  const {
    success
  } = useToast();
  const pricingData = [{
    format: 'Баннер на главной (TOP)',
    placement: '1140×250',
    duration: '1 неделя',
    impressions: '~40,000',
    price: '50 000 ₽'
  }, {
    format: 'Баннер на главной (после отзывов)',
    placement: '1140×250',
    duration: '2 недели',
    impressions: '~60,000',
    price: '35 000 ₽'
  }, {
    format: 'Баннер в каталоге (сайдбар)',
    placement: '300×600',
    duration: '1 неделя',
    impressions: '~25,000',
    price: '20 000 ₽'
  }, {
    format: 'Каталог — между карточками',
    placement: 'Нативная карточка',
    duration: '2 недели',
    impressions: '~30,000',
    price: '12 000 ₽'
  }, {
    format: 'Закреп астролога в топе',
    placement: 'Карточка',
    duration: '1 месяц',
    impressions: '~100,000',
    price: '15 000 ₽'
  }, {
    format: 'Профиль астролога — рекомендации',
    placement: 'Карточка',
    duration: '1 месяц',
    impressions: '~45,000',
    price: '10 000 ₽'
  }, {
    format: 'Баннер в блоге (внутри статьи)',
    placement: '728×90',
    duration: '1 месяц',
    impressions: '~60,000',
    price: '12 000 ₽'
  }, {
    format: 'Блог — сайдбар',
    placement: '300×600',
    duration: '2 недели',
    impressions: '~25,000',
    price: '15 000 ₽'
  }, {
    format: 'Гороскоп — баннер',
    placement: '728×90',
    duration: '2 недели',
    impressions: '~45,000',
    price: '18 000 ₽'
  }, {
    format: 'Гороскоп — сайдбар',
    placement: '300×250',
    duration: '1 неделя',
    impressions: '~40,000',
    price: '12 000 ₽'
  }, {
    format: 'Лунный календарь — баннер',
    placement: '728×90',
    duration: '2 недели',
    impressions: '~30,000',
    price: '14 000 ₽'
  }, {
    format: 'Бесплатная карта — после результата',
    placement: '728×90',
    duration: '1 месяц',
    impressions: '~15,000',
    price: '22 000 ₽'
  }, {
    format: 'Совместимость — после результата',
    placement: '728×90',
    duration: '1 месяц',
    impressions: '~10,000',
    price: '20 000 ₽'
  }, {
    format: 'Результат отчёта — апсейл',
    placement: 'Нативная карточка',
    duration: '1 месяц',
    impressions: '~5,000',
    price: '25 000 ₽'
  }, {
    format: 'Страница услуг — кросс-продажи',
    placement: 'Нативная карточка',
    duration: '1 месяц',
    impressions: '~8,000',
    price: '16 000 ₽'
  }, {
    format: 'FAQ — баннер',
    placement: '728×90',
    duration: '1 месяц',
    impressions: '~4,000',
    price: '8 000 ₽'
  }, {
    format: 'Мобильный sticky баннер',
    placement: '320×50',
    duration: '1 неделя',
    impressions: '~350,000',
    price: '30 000 ₽'
  }, {
    format: 'Нативная статья',
    placement: 'Блог + Анонс',
    duration: 'Навсегда',
    impressions: '~15,000',
    price: '35 000 ₽'
  }, {
    format: 'Email-рассылка (отдельное письмо)',
    placement: 'Отдельное письмо',
    duration: '1 рассылка',
    impressions: '~45,000',
    price: '40 000 ₽'
  }, {
    format: 'Email-рассылка (блок в дайджесте)',
    placement: 'Блок в дайджесте',
    duration: '1 рассылка',
    impressions: '~45,000',
    price: '25 000 ₽'
  }];
  const placementMap = [{
    title: 'Главная',
    icon: <Home className="w-5 h-5 text-indigo-500" data-id="element-20960" />,
    slots: 2,
    types: ['Banner'],
    priceRange: '35 000 ₽ - 50 000 ₽',
    impressions: '~100,000/мес',
    color: 'bg-indigo-50 border-indigo-100'
  }, {
    title: 'Каталог астрологов',
    icon: <Users className="w-5 h-5 text-blue-500" data-id="element-20961" />,
    slots: 3,
    types: ['Banner', 'Pinned', 'Native'],
    priceRange: '10 000 ₽ - 20 000 ₽',
    impressions: '~150,000/мес',
    color: 'bg-blue-50 border-blue-100'
  }, {
    title: 'Блог',
    icon: <FileText className="w-5 h-5 text-emerald-500" data-id="element-20962" />,
    slots: 2,
    types: ['Banner', 'Native'],
    priceRange: '12 000 ₽ - 15 000 ₽',
    impressions: '~85,000/мес',
    color: 'bg-emerald-50 border-emerald-100'
  }, {
    title: 'Гороскоп',
    icon: <Star className="w-5 h-5 text-amber-500" data-id="element-20963" />,
    slots: 2,
    types: ['Banner', 'Native'],
    priceRange: '12 000 ₽ - 18 000 ₽',
    impressions: '~85,000/мес',
    color: 'bg-amber-50 border-amber-100'
  }, {
    title: 'Сервисные страницы',
    icon: <Layers className="w-5 h-5 text-purple-500" data-id="element-20964" />,
    slots: 4,
    types: ['Native'],
    priceRange: '16 000 ₽ - 25 000 ₽',
    impressions: '~38,000/мес',
    color: 'bg-purple-50 border-purple-100'
  }, {
    title: 'Лунный календарь',
    icon: <Moon className="w-5 h-5 text-slate-500" data-id="element-20965" />,
    slots: 1,
    types: ['Banner'],
    priceRange: '14 000 ₽',
    impressions: '~30,000/мес',
    color: 'bg-slate-100 border-slate-200'
  }, {
    title: 'FAQ',
    icon: <HelpCircle className="w-5 h-5 text-rose-500" data-id="element-20966" />,
    slots: 1,
    types: ['Banner'],
    priceRange: '8 000 ₽',
    impressions: '~4,000/мес',
    color: 'bg-rose-50 border-rose-100'
  }, {
    title: 'Email',
    icon: <Mail className="w-5 h-5 text-teal-500" data-id="element-20967" />,
    slots: 2,
    types: ['Email'],
    priceRange: '25 000 ₽ - 40 000 ₽',
    impressions: '~45,000/рассылка',
    color: 'bg-teal-50 border-teal-100'
  }, {
    title: 'Мобильный',
    icon: <Smartphone className="w-5 h-5 text-cyan-500" data-id="element-20968" />,
    slots: 1,
    types: ['Banner'],
    priceRange: '30 000 ₽',
    impressions: '~350,000/мес',
    color: 'bg-cyan-50 border-cyan-100'
  }];
  return <div className="w-full bg-slate-50 pb-24" data-id="element-20969">
      <div className="bg-white border-b border-slate-200 pt-8 pb-16" data-id="element-20970">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-20971">
          <Breadcrumbs items={[{
          label: 'Главная',
          onClick: () => onNavigate('home')
        }, {
          label: 'Реклама'
        }]} className="mb-8" data-id="element-20972" />
          <div className="text-center max-w-4xl mx-auto mt-8" data-id="element-20973">
            <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6" data-id="element-20974">
              Реклама на платформе
            </h1>
            <p className="text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-20975">
              Доступ к целевой аудитории, заинтересованной в самопознании,
              психологии и эзотерике. Более 100 000 уникальных посетителей в
              месяц.
            </p>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12" data-id="element-20976">
        {/* Audience Stats */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-20" data-id="element-20977">
          <Card padding="lg" className="text-center" data-id="element-20978">
            <div className="text-3xl font-bold text-primary mb-2" data-id="element-20979">120 000+</div>
            <div className="text-sm text-slate-600" data-id="element-20980">
              уникальных посетителей/мес
            </div>
          </Card>
          <Card padding="lg" className="text-center" data-id="element-20981">
            <div className="text-3xl font-bold text-primary mb-2" data-id="element-20982">85%</div>
            <div className="text-sm text-slate-600" data-id="element-20983">женщины 25-45 лет</div>
          </Card>
          <Card padding="lg" className="text-center" data-id="element-20984">
            <div className="text-3xl font-bold text-primary mb-2" data-id="element-20985">4.2 мин</div>
            <div className="text-sm text-slate-600" data-id="element-20986">средняя сессия</div>
          </Card>
          <Card padding="lg" className="text-center" data-id="element-20987">
            <div className="text-3xl font-bold text-primary mb-2" data-id="element-20988">45 000</div>
            <div className="text-sm text-slate-600" data-id="element-20989">email-подписчиков</div>
          </Card>
        </div>

        <h2 className="text-3xl font-bold text-slate-900 mb-8 text-center" data-id="element-20990">
          Рекламные форматы
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-20991">
          <Card padding="lg" className="flex flex-col" data-id="element-20992">
            <div className="w-full h-32 bg-slate-100 rounded-xl mb-6 flex flex-col items-center justify-center border border-slate-200 relative overflow-hidden" data-id="element-20993">
              {/* Mockup visual */}
              <div className="w-full h-4 bg-slate-200 absolute top-0" data-id="element-20994"></div>
              <div className="w-3/4 h-12 bg-indigo-100 border border-indigo-200 rounded flex items-center justify-center text-indigo-500 text-xs font-medium" data-id="element-20995">
                Место для баннера
              </div>
              <div className="w-full h-8 bg-slate-200 absolute bottom-0 flex gap-2 px-4 items-center" data-id="element-20996">
                <div className="w-8 h-8 rounded-full bg-slate-300" data-id="element-20997"></div>
                <div className="w-16 h-2 bg-slate-300 rounded" data-id="element-20998"></div>
              </div>
            </div>

            <div className="flex items-center mb-3" data-id="element-20999">
              <div className="w-8 h-8 rounded-lg bg-indigo-100 flex items-center justify-center text-primary mr-3" data-id="element-21000">
                <Monitor className="w-4 h-4" data-id="element-21001" />
              </div>
              <h3 className="text-xl font-bold text-slate-900" data-id="element-21002">
                Баннер на главной
              </h3>
            </div>
            <p className="text-slate-600 text-sm mb-6 flex-grow" data-id="element-21003">
              Заметный блок на главной странице сайта. Максимальный охват
              аудитории.
            </p>

            <div className="bg-slate-50 p-4 rounded-xl mb-6" data-id="element-21004">
              <div className="text-xs text-slate-500 uppercase tracking-wider font-semibold mb-2" data-id="element-21005">
                Спецификации
              </div>
              <ul className="space-y-1 text-sm text-slate-700" data-id="element-21006">
                <li data-id="element-21007">
                  <span className="text-slate-500" data-id="element-21008">Размер:</span> 1140x250px
                </li>
                <li data-id="element-21009">
                  <span className="text-slate-500" data-id="element-21010">Формат:</span> JPG, PNG, GIF
                </li>
                <li data-id="element-21011">
                  <span className="text-slate-500" data-id="element-21012">Вес:</span> до 500 КБ
                </li>
              </ul>
            </div>

            <div className="font-bold text-xl text-slate-900" data-id="element-21013">
              от 50 000 ₽{' '}
              <span className="text-sm font-normal text-slate-500" data-id="element-21014">
                / неделя
              </span>
            </div>
          </Card>

          <Card padding="lg" className="flex flex-col" data-id="element-21015">
            <div className="w-full h-32 bg-slate-100 rounded-xl mb-6 flex flex-col items-center justify-center border border-slate-200 relative overflow-hidden" data-id="element-21016">
              {/* Mockup visual */}
              <div className="w-full h-full flex p-4 gap-4" data-id="element-21017">
                <div className="w-1/3 h-full bg-slate-200 rounded" data-id="element-21018"></div>
                <div className="w-2/3 flex flex-col gap-2" data-id="element-21019">
                  <div className="w-full h-4 bg-slate-300 rounded" data-id="element-21020"></div>
                  <div className="w-3/4 h-3 bg-slate-200 rounded" data-id="element-21021"></div>
                  <div className="w-full h-12 bg-amber-100 border border-amber-200 rounded mt-auto flex items-center justify-center text-amber-600 text-xs font-medium" data-id="element-21022">
                    Нативная вставка
                  </div>
                </div>
              </div>
            </div>

            <div className="flex items-center mb-3" data-id="element-21023">
              <div className="w-8 h-8 rounded-lg bg-amber-100 flex items-center justify-center text-amber-600 mr-3" data-id="element-21024">
                <FileText className="w-4 h-4" data-id="element-21025" />
              </div>
              <h3 className="text-xl font-bold text-slate-900" data-id="element-21026">
                Нативная статья
              </h3>
            </div>
            <p className="text-slate-600 text-sm mb-6 flex-grow" data-id="element-21027">
              Публикация в нашем блоге с анонсом на главной странице и в
              соцсетях.
            </p>

            <div className="bg-slate-50 p-4 rounded-xl mb-6" data-id="element-21028">
              <div className="text-xs text-slate-500 uppercase tracking-wider font-semibold mb-2" data-id="element-21029">
                Особенности
              </div>
              <ul className="space-y-1 text-sm text-slate-700" data-id="element-21030">
                <li data-id="element-21031">
                  <span className="text-slate-500" data-id="element-21032">SEO:</span> Вечная ссылка
                  (Dofollow)
                </li>
                <li data-id="element-21033">
                  <span className="text-slate-500" data-id="element-21034">Текст:</span> Наш редактор
                </li>
                <li data-id="element-21035">
                  <span className="text-slate-500" data-id="element-21036">Бонус:</span> Анонс в
                  Telegram
                </li>
              </ul>
            </div>

            <div className="font-bold text-xl text-slate-900" data-id="element-21037">
              35 000 ₽{' '}
              <span className="text-sm font-normal text-slate-500" data-id="element-21038">
                / статья
              </span>
            </div>
          </Card>

          <Card padding="lg" className="flex flex-col" data-id="element-21039">
            <div className="w-full h-32 bg-slate-100 rounded-xl mb-6 flex flex-col items-center justify-center border border-slate-200 relative overflow-hidden" data-id="element-21040">
              {/* Mockup visual */}
              <div className="w-2/3 h-full bg-white shadow-sm border border-slate-200 flex flex-col p-2 gap-2" data-id="element-21041">
                <div className="w-full h-3 bg-slate-200 rounded" data-id="element-21042"></div>
                <div className="w-full h-12 bg-emerald-50 border border-emerald-200 rounded flex items-center justify-center text-emerald-600 text-[10px] font-medium text-center leading-tight" data-id="element-21043">
                  Ваш блок
                  <br data-id="element-21044" />в рассылке
                </div>
                <div className="w-full h-2 bg-slate-100 rounded mt-auto" data-id="element-21045"></div>
              </div>
            </div>

            <div className="flex items-center mb-3" data-id="element-21046">
              <div className="w-8 h-8 rounded-lg bg-emerald-100 flex items-center justify-center text-emerald-600 mr-3" data-id="element-21047">
                <Mail className="w-4 h-4" data-id="element-21048" />
              </div>
              <h3 className="text-xl font-bold text-slate-900" data-id="element-21049">
                Email-рассылка
              </h3>
            </div>
            <p className="text-slate-600 text-sm mb-6 flex-grow" data-id="element-21050">
              Включение вашего блока в еженедельный дайджест или отдельное
              письмо.
            </p>

            <div className="bg-slate-50 p-4 rounded-xl mb-6" data-id="element-21051">
              <div className="text-xs text-slate-500 uppercase tracking-wider font-semibold mb-2" data-id="element-21052">
                Метрики
              </div>
              <ul className="space-y-1 text-sm text-slate-700" data-id="element-21053">
                <li data-id="element-21054">
                  <span className="text-slate-500" data-id="element-21055">База:</span> 45 000+
                  подписчиков
                </li>
                <li data-id="element-21056">
                  <span className="text-slate-500" data-id="element-21057">Open Rate:</span> ~28%
                </li>
                <li data-id="element-21058">
                  <span className="text-slate-500" data-id="element-21059">CTR:</span> ~4.5%
                </li>
              </ul>
            </div>

            <div className="font-bold text-xl text-slate-900" data-id="element-21060">
              от 25 000 ₽{' '}
              <span className="text-sm font-normal text-slate-500" data-id="element-21061">
                / выпуск
              </span>
            </div>
          </Card>
        </div>

        {/* Placement Map */}
        <h2 className="text-3xl font-bold text-slate-900 mb-4 text-center" data-id="element-21062">
          Карта размещений
        </h2>
        <p className="text-center text-slate-600 max-w-2xl mx-auto mb-8" data-id="element-21063">
          Мы предлагаем 18 рекламных слотов на различных страницах платформы,
          чтобы вы могли точно таргетировать свою аудиторию.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-20" data-id="element-21064">
          {placementMap.map((area, idx) => <Card key={idx} padding="sm" className={`border ${area.color} hover:shadow-md transition-shadow`} data-id="element-21065">
              <div className="flex items-start justify-between mb-3" data-id="element-21066">
                <div className="flex items-center gap-2" data-id="element-21067">
                  <div className="p-2 bg-white rounded-lg shadow-sm" data-id="element-21068">
                    {area.icon}
                  </div>
                  <h3 className="font-bold text-slate-900" data-id="element-21069">{area.title}</h3>
                </div>
                <Badge variant="neutral" size="sm" data-id="element-21070">
                  {area.slots} слота
                </Badge>
              </div>
              <div className="space-y-2 text-sm" data-id="element-21071">
                <div className="flex justify-between" data-id="element-21072">
                  <span className="text-slate-500" data-id="element-21073">Форматы:</span>
                  <span className="font-medium text-slate-700" data-id="element-21074">
                    {area.types.join(', ')}
                  </span>
                </div>
                <div className="flex justify-between" data-id="element-21075">
                  <span className="text-slate-500" data-id="element-21076">Охват:</span>
                  <span className="font-medium text-slate-700" data-id="element-21077">
                    {area.impressions}
                  </span>
                </div>
                <div className="flex justify-between pt-2 border-t border-slate-200/50" data-id="element-21078">
                  <span className="text-slate-500" data-id="element-21079">Бюджет:</span>
                  <span className="font-bold text-slate-900" data-id="element-21080">
                    {area.priceRange}
                  </span>
                </div>
              </div>
            </Card>)}
        </div>

        {/* Pricing Table */}
        <h2 className="text-3xl font-bold text-slate-900 mb-8 text-center" data-id="element-21081">
          Подробный прайс-лист
        </h2>
        <Card padding="none" className="overflow-hidden mb-20 overflow-x-auto" data-id="element-21082">
          <table className="min-w-full text-left text-sm" data-id="element-21083">
            <thead className="bg-slate-50 text-slate-600 border-b border-slate-200" data-id="element-21084">
              <tr data-id="element-21085">
                <th className="px-6 py-4 font-semibold" data-id="element-21086">Формат</th>
                <th className="px-6 py-4 font-semibold" data-id="element-21087">Размещение</th>
                <th className="px-6 py-4 font-semibold" data-id="element-21088">Срок</th>
                <th className="px-6 py-4 font-semibold" data-id="element-21089">Показы (прогноз)</th>
                <th className="px-6 py-4 font-semibold text-right" data-id="element-21090">Цена</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-21091">
              {pricingData.map((row, index) => <tr key={index} className="hover:bg-slate-50 transition-colors" data-id="element-21092">
                  <td className="px-6 py-4 font-medium text-slate-900" data-id="element-21093">
                    {row.format}
                  </td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-21094">{row.placement}</td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-21095">{row.duration}</td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-21096">
                    {row.impressions}
                  </td>
                  <td className="px-6 py-4 font-bold text-slate-900 text-right" data-id="element-21097">
                    {row.price}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </Card>

        {/* Why Us */}
        <h2 className="text-3xl font-bold text-slate-900 mb-8 text-center" data-id="element-21098">
          Почему мы?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-24" data-id="element-21099">
          <Card padding="lg" data-id="element-21100">
            <Target className="w-8 h-8 text-primary mb-4" data-id="element-21101" />
            <h3 className="font-bold text-slate-900 mb-2" data-id="element-21102">Целевая аудитория</h3>
            <p className="text-sm text-slate-600" data-id="element-21103">
              Платежеспособная аудитория, активно интересующаяся саморазвитием.
            </p>
          </Card>
          <Card padding="lg" data-id="element-21104">
            <CheckCircle2 className="w-8 h-8 text-emerald-500 mb-4" data-id="element-21105" />
            <h3 className="font-bold text-slate-900 mb-2" data-id="element-21106">
              Высокая вовлечённость
            </h3>
            <p className="text-sm text-slate-600" data-id="element-21107">
              Пользователи проводят на сайте много времени, изучая объемные
              отчеты.
            </p>
          </Card>
          <Card padding="lg" data-id="element-21108">
            <Settings className="w-8 h-8 text-amber-500 mb-4" data-id="element-21109" />
            <h3 className="font-bold text-slate-900 mb-2" data-id="element-21110">Гибкие форматы</h3>
            <p className="text-sm text-slate-600" data-id="element-21111">
              Подберем оптимальный формат под ваши задачи и бюджет.
            </p>
          </Card>
          <Card padding="lg" data-id="element-21112">
            <BarChart className="w-8 h-8 text-indigo-500 mb-4" data-id="element-21113" />
            <h3 className="font-bold text-slate-900 mb-2" data-id="element-21114">
              Прозрачная аналитика
            </h3>
            <p className="text-sm text-slate-600" data-id="element-21115">
              Предоставляем подробные отчеты по показам и кликам после кампании.
            </p>
          </Card>
        </div>

        {/* Contact Form */}
        <Card padding="lg" className="max-w-3xl mx-auto border-none shadow-xl" data-id="element-21116">
          <div className="text-center mb-8" data-id="element-21117">
            <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-21118">
              Оставить заявку
            </h2>
            <p className="text-slate-600" data-id="element-21119">
              Заполните форму, и наш менеджер свяжется с вами для обсуждения
              деталей.
            </p>
          </div>

          <form className="space-y-6" data-id="element-21120">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-21121">
              <Input label="Компания / Бренд" placeholder="Название вашей компании" data-id="element-21122" />
              <Input label="Контактное лицо" placeholder="Ваше имя" data-id="element-21123" />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-21124">
              <Input label="Email" type="email" placeholder="work@example.com" data-id="element-21125" />
              <Input label="Телефон" type="tel" placeholder="+7 (999) 000-00-00" data-id="element-21126" />
            </div>

            <div data-id="element-21127">
              <label className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-21128">
                Ориентировочный бюджет
              </label>
              <select className="block w-full rounded-xl border-slate-200 shadow-sm focus:ring-primary focus:border-primary sm:text-sm px-4 py-2.5 border outline-none text-slate-900 bg-white appearance-none" data-id="element-21129">
                <option value="" data-id="element-21130">Выберите бюджет...</option>
                <option value="under50" data-id="element-21131">До 50 000 ₽</option>
                <option value="50to200" data-id="element-21132">50 000 ₽ - 200 000 ₽</option>
                <option value="over200" data-id="element-21133">Более 200 000 ₽</option>
              </select>
            </div>

            <div data-id="element-21134">
              <label className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-21135">
                Комментарий или вопросы
              </label>
              <textarea rows={4} className="block w-full rounded-xl border-slate-200 shadow-sm focus:ring-primary focus:border-primary sm:text-sm px-4 py-2.5 border outline-none text-slate-900 resize-none" placeholder="Опишите ваш продукт и цели рекламной кампании..." data-id="element-21136"></textarea>
            </div>

            <div className="pt-4" data-id="element-21137">
              <Button size="lg" fullWidth type="button" onClick={() => {
              success('Заявка на рекламу отправлена! Мы свяжемся с вами в течение 24 часов.');
            }} data-id="element-21138">
                Отправить заявку
              </Button>
              <p className="text-center text-sm text-slate-500 mt-4" data-id="element-21139">
                Мы свяжемся с вами в течение 1 рабочего дня
              </p>
            </div>
          </form>
        </Card>
      </div>
    </div>;
}